import axios from 'axios'
import NProgress from 'nprogress'
import router from '@/routers/router'
import 'nprogress/nprogress.css';
let templatex = `
<div class="bar" role="bar">
    <div class="peg"></div>
</div>
<div class="spinner container-fluid" role="spinner">

<div class="row align-items-center" style="height: 100%">
  <div class="col text-center">
    <div class="spinner-icon" style="height: 100px; width: 100px; margin: 0 auto;"></div>
  </div>
</div>
</div>
`
NProgress.configure({
    template: templatex,
    speed: 500
});
import Notifications from "@/notifications/notifications";
export default (loading = true) => {
    var headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }
    if (localStorage.getItem('token')) {
        headers.Authorization = "JWT " + localStorage.getItem('token');
    }
    const axiosInstance = axios.create({
        // baseURL: `http://192.168.250.82:8000/api`,
        baseURL: process.env.VUE_APP_ROOT_API,
        // `http://localhost:8000/api`,
        // baseURL: `http://192.168.250.84:8000/api`,
        withCredentials: false,
        headers: headers
    })
    // before a request is made start the nprogress
    axiosInstance.interceptors.request.use(config => {
        if (loading) {
            NProgress.start()
        }
        return config
    })

    // before a response is returned stop nprogress
    axiosInstance.interceptors.response.use(function (response) {
        if (loading) {
            setTimeout(() => {  
                NProgress.done();
                NProgress.remove();                
             }, 100);
        }

        return response;
    }, function (error, d) {
        if (loading) {
            setTimeout(() => {  
                NProgress.done();
                NProgress.remove();                
             }, 100);
        }

        if (!error.response) {
            localStorage.removeItem("token");
            router.push({
                name: 'login'
            });
        }
        if (error.response.status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("ocultar_checklist_info");
            router.push({
                name: 'login'
            });
        }
        if (error.response.status === 403) {
            Notifications.alert.error(
                "Acceso denegado",
                error.response.data.detail
            );
        }
        return Promise.reject(error);
    });

    return axiosInstance
}